import styled from 'styled-components';

export const Headers = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  font-size: 20px;

  span {
    font-family: "Inter";
    color: #333333;
  }
`;
